import ExportTaskPopover from './export-task-popover.vue'
ExportTaskPopover.install = function (Vue) {
	Vue.component(ExportTaskPopover.name, ExportTaskPopover);
}

export default ExportTaskPopover